import React, { FC, ReactNode, useRef } from 'react'
import { CircularProgress } from '@mui/material'
import { classNames } from '../../utils/cssUtils'
import './MVPButton.scss'

export type HTMLButtonType = 'submit' | 'reset' | 'button' | undefined

export interface MVPButtonProps {
	id?: string
	className?: string
	children?: ReactNode | ReactNode[]
	type?: HTMLButtonType
	onClick?: () => void
	loading?: boolean
	onMouseEnter?: React.MouseEventHandler<HTMLButtonElement>
	onMouseLeave?: React.MouseEventHandler<HTMLButtonElement>
	disabled?: boolean
	href?: string
}

export const MVPButton = React.forwardRef<HTMLButtonElement, MVPButtonProps>(
	({ id, className, children, type, onClick, loading, onMouseEnter, onMouseLeave, disabled, href }: MVPButtonProps, ref) => {
		const defType = type ?? 'button'

		const content = loading ? <CircularProgress className='mvp-button-loading-indicator' size={30} /> : children

		const cs = classNames(`mvp-button ${className ?? ''}`, {
			disabled: !!disabled,
		})

		if (href && !onClick) {
			// eslint-disable-next-line no-param-reassign
			onClick = () => {
				window.open(href, '_blank', 'noopener noreferrer')
			}
		}

		return (
			<button
				id={id}
				className={cs}
				ref={ref}
				// eslint-disable-next-line react/button-has-type
				type={defType ?? 'button'}
				onClick={disabled ? undefined : onClick}
				onMouseEnter={onMouseEnter}
				onMouseLeave={onMouseLeave}
			>
				{content}
			</button>
		)
	},
)
